import { useAppSelector } from "../../../../app/hooks";
import { RootState } from "../../../../app/store";
import Localized from "../../../../Localized";
import './style.scss';

const Summary = () => {

    const { stepCurrent } = useAppSelector((state: RootState) => state.windowSlice);

    const { totalCount, isPaymentPromo, servicePrice } = useAppSelector((state: RootState) => state.orderSlice);

    const { goods, selected } = useAppSelector((state: RootState) => state.orderSlice);

    let amount = 0;
    let service = 0;
    let totalPrice = 0;

    goods.filter((item) => selected.includes(item.categoryId))
    .sort((a, b) => selected.indexOf(a.categoryId) - selected.indexOf(b.categoryId))
    .map((item) => {
        if(item.isActivatePromo) {
            amount = amount + Number(item.prices.promo) * item.count;
        } else {
            amount = amount + Number(item.prices.standart) * item.count;
        }
        service = service + Number(item.prices.service) * item.count;
        totalPrice = amount + service;
        return true;
    });


    const declOfNum = (number: number, titles: any[]) => {  
        let cases = [2, 0, 1, 1, 1, 2];  
        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];  
    }
    const textCount = totalCount + ' ' + declOfNum(totalCount, [Localized.SummaryTicket, Localized.Summary2Tickets, Localized.SummaryTickets]);

    const paymentMethod = () => {
         if(isPaymentPromo) {
             return (
                <div className="summary_information">
                    <span className="summary_information_text">{Localized.SpanSpecialPaymentMethod}</span>
                </div>
             );
         }
    }

    return (
        <div className="summary" style={stepCurrent>0 ? {transform: 'translateY(0)', opacity: '1',  pointerEvents: 'all'} : {}}>
            <div className="summary_container">
                <div className="summary_wrapper">
                    <div className="summary_count">
                        <span className="summary_count_text"><b>{textCount}</b> {Localized.SummarySum}</span>
                        <span className="summary_count_price">{(amount/100).toFixed(2)} Br</span>
                    </div>
                    <div className="summary_service">
                        <span className="summary_service_text">{Localized.SummaryService} ({totalCount} х {(Number(servicePrice)/100).toFixed(2)} Br)</span>
                        <span className="summary_service_price">{(service/100).toFixed(2)} Br</span>
                    </div>
                    <div className="summary_total">
                        <span className="summary_total_text">{Localized.SummaryTotal}</span>
                        <span className="summary_total_price">{(totalPrice/100).toFixed(2)} Br</span>
                    </div>
                    {paymentMethod()}
                </div>
            </div>
        </div>
    );
}

export default Summary;